import React from 'react';
import './style.css'

function AnimateButton() {
    return (
        <div>
            <button className='buttonsANIMATE' style={{fontSize:'10px',borderRadius:'10px', '--content': '"ASSIGN ME!"'}}>
                <div class="left"></div>
                Assign Me
                <div class="right"></div>
            </button>
        </div>
    );
}

export default AnimateButton;
